import { BaseModel } from "@blue-chip/core";
import PurchaseOrder from "./PurchaseOrder";
import BidGroup from "./BidGroup";

export default class BidGroupPurchaseOrder extends BaseModel {
  static get belongsTo() {
    return [BidGroup, PurchaseOrder];
  }
}
